import { useUserQuery } from "../common/lib/fetch";
import { useUser } from "../userAccess/useUser";

export interface AvailableBayDto {
  id: string;
  name: string;
  isCompatible: boolean;
  isTemporarilyDisabled: boolean;
}

export const useGetAvailableBaysForStagedPurchaseOrder = (stagedPurchaseOrderId: string) => {
  const user = useUser();

  return useUserQuery<AvailableBayDto[]>({
    path: `/api/sites/${user.selectedSite?.id}/stagedPurchaseOrders/${stagedPurchaseOrderId}/availableBays`,
  });
}
